import { ComponentCreateRequestRequestPriority } from '@gql/graphql';
import { type NewComponentRequestFormValue } from '@components/NewComponentCreateRequestTrigger/components/NewComponentsRequestDialog/components/NewComponentRequestForm';
import { type StringOption } from '@models/Option';
import { type RequestRow } from '@pages/notification-components/components/RequestsCard/RequestsTable/columns';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';

type RequestData = RequestRow | ComponentCreateRequestMapped;

export function getRequestVendorInitialValue(
    request: RequestData,
): string | StringOption {
    if ('componentVendor' in request && request.componentVendor) {
        return {
            label: request.componentVendor.name,
            value: request.componentVendor.id,
        };
    }
    if (
        'componentVendorID' in request &&
        request.componentVendorID &&
        request.componentVendorName
    ) {
        return {
            label: request.componentVendorName,
            value: request.componentVendorID,
        };
    }
    return request.componentVendorName ?? '';
}

export function getRequestFormDefaultValues(
    request: RequestData,
): NewComponentRequestFormValue {
    return {
        id: request.id,
        componentVendor: getRequestVendorInitialValue(request),
        componentName: request.componentName ?? '',
        componentVersion: request.componentVersion ?? '',
        requestPriority:
            request.requestPriority ??
            ComponentCreateRequestRequestPriority.Low,
        referenceWeb: request.referenceWeb ?? '',
        referenceSecurity: request.referenceSecurity ?? '',
    };
}
